export default "__VITE_ASSET__CNh4CBi3__"